import { getSlots } from "@/mds/utils/slots";
import { MDSCardSlotName, MDSIcon, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import {
  StyledButton,
  StyledCardIcon,
  StyledCardTitle,
  StyledCardRightAddon,
  StyledCardDescription,
  StyledButtonContent,
  StyledCardHeader,
} from "./integration-item-card.style";
import { IntegrationItemProps } from "./integration-item-card.types";

export function IntegrationItemCard(props: IntegrationItemProps) {
  const { mdsIcon, title, description, children, onPress, ...rest } = props;

  const rightAddon = getSlots(children, MDSCardSlotName.RightAddon);

  const hasRightAddon = rightAddon.length > 0;

  return (
    <StyledButton {...rest} onPress={onPress}>
      <StyledButtonContent>
        {hasRightAddon && <StyledCardRightAddon>{rightAddon}</StyledCardRightAddon>}
        <StyledCardHeader>
          <StyledCardIcon>
            <MDSIcon kind={mdsIcon} />
          </StyledCardIcon>
          <StyledCardTitle
            variant={MDSTextVariant.TextM}
            weight={MDSTextWeight.Smedium}
            color={MDSTextColor.Contrast}
          >
            {title}
          </StyledCardTitle>
        </StyledCardHeader>
        <StyledCardDescription variant={MDSTextVariant.ParagraphS}>
          {description}
        </StyledCardDescription>
      </StyledButtonContent>
    </StyledButton>
  );
}
